import { useMemo } from 'react';

import { useConfig } from '@occc/config';

export function useSubBrandByUuid(subBrandUuid?: string | null) {
  const {
    config: { subBrands },
  } = useConfig();

  return useMemo(() => {
    const list = subBrands?.enabled ? subBrands.list : [];

    return list.find((subBrand) => subBrand.uuid === subBrandUuid);
  }, [subBrands, subBrandUuid]);
}
